import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseBlockUpdated.meta';

export type ShowcaseBlockUpdatedField =
  | 'style'
  | 'alignment'
  | 'size'
  | 'inset_width'
  | 'image_layout'
  | 'video_layout'
  | 'video_playback';

export type UseTrackShowcaseBlockUpdatedParams = {
  field_updated: ShowcaseBlockUpdatedField;
};

export const useTrackShowcaseBlockUpdated = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseBlockUpdated = useCallback(
    (params: UseTrackShowcaseBlockUpdatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShowcaseBlockUpdated };
};
